export const TRIAL_PRESET_DAYS = [7, 15, 30, 90];

const parsePtBrDateToInput = (value) => {
  if (typeof value !== 'string' || !/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return '';
  const [day, month, year] = value.split('/');
  return `${year}-${month}-${day}`;
};

const extractSguTrialDateValue = (value) => {
  if (!value) return '';
  if (typeof value === 'object') {
    return value.trialEndDate || value.sguTrial || value.trialEndDatePtBr || '';
  }
  return value;
};

export const formatSguTrialDateForInput = (value) => {
  const raw = extractSguTrialDateValue(value);
  if (!raw) return '';

  const ptBr = parsePtBrDateToInput(raw);
  if (ptBr) return ptBr;

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return '';
  return parsed.toISOString().slice(0, 10);
};

export const normalizeSguTrialFromApi = (value) => {
  if (value === null || value === undefined) return null;

  if (typeof value === 'string' || typeof value === 'number') {
    const formatted = formatSguTrialDateForInput(value);
    return formatted || null;
  }

  if (typeof value === 'object') {
    const isTrial =
      value.status === 'trial' ||
      value.code === 'trial' ||
      Boolean(value.trialEndDate || value.trialEndDatePtBr || value.sguTrial);

    if (!isTrial) return null;

    const formatted = formatSguTrialDateForInput(value);
    return formatted || '';
  }

  return null;
};

export const formatApiStatusMessage = (status, fallback = 'Ocorreu um erro.') => {
  if (typeof status === 'string') return status;
  if (!status || typeof status !== 'object') return fallback;

  if (typeof status.status === 'string') return status.status;
  if (status.trialEndDatePtBr) {
    return `Trial SGU configurado até ${status.trialEndDatePtBr}.`;
  }
  if (status.message) return status.message;

  return fallback;
};

export const buildSguTrialPayloadValue = (value) => {
  const dateOnly = formatSguTrialDateForInput(value);
  if (!dateOnly) return null;
  return new Date(`${dateOnly}T23:59:59.999`).toISOString();
};

export const formatSguTrialDateForDisplay = (value) => {
  const dateOnly = formatSguTrialDateForInput(value);
  if (!dateOnly) return '';
  const [year, month, day] = dateOnly.split('-');
  return `${day}/${month}/${year}`;
};

export const addDaysFromToday = (days) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString().slice(0, 10);
};

export const getSguTrialDaysRemaining = (dateStr) => {
  const dateOnly = formatSguTrialDateForInput(dateStr);
  if (!dateOnly) return null;
  const end = new Date(`${dateOnly}T23:59:59`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.ceil((end - today) / (1000 * 60 * 60 * 24));
};

export const isSguTrialMode = (sguTrial) => {
  if (sguTrial === null || sguTrial === undefined) return false;
  if (typeof sguTrial === 'object') {
    return normalizeSguTrialFromApi(sguTrial) !== null;
  }
  return true;
};

export const getSguLinkedCompanyNames = (user, companyById, isSingleManagerType) => {
  if (isSingleManagerType && user?.managerId) {
    const name = companyById[user.managerId]?.name;
    return name ? [name] : [];
  }
  return (Array.isArray(user?.allowedUnitIds) ? user.allowedUnitIds : [])
    .map((id) => companyById[id]?.name)
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b, 'pt-BR'));
};

export const hasSguCompanyLink = (accessType, managerId, allowedUnitIds) => {
  const isSingleManagerType =
    accessType === 'cooperative_manager' || accessType === 'unit_manager';
  const isMultiUnitManagerType = accessType === 'multi_unit_manager';
  const unitIds = Array.isArray(allowedUnitIds) ? allowedUnitIds : [];

  return (
    (isSingleManagerType && Boolean(managerId)) ||
    (isMultiUnitManagerType && unitIds.length > 0)
  );
};

export const getSguTrialStatusMeta = (dateStr) => {
  const days = getSguTrialDaysRemaining(dateStr);
  if (days === null) return null;
  if (days < 0) {
    return { variant: 'danger', label: 'Trial expirado', days };
  }
  if (days === 0) {
    return { variant: 'warning', label: 'Expira hoje', days };
  }
  if (days <= 7) {
    return { variant: 'warning', label: `${days} dia${days === 1 ? '' : 's'} restante${days === 1 ? '' : 's'}`, days };
  }
  return { variant: 'info', label: `${days} dias restantes`, days };
};
